webpackJsonp([162114328119038],{

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(82);
	
	var _PostIcons = __webpack_require__(87);
	
	var _PostIcons2 = _interopRequireDefault(_PostIcons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Category = function Category(_ref) {
	    var data = _ref.data;
	    return Glamor.createElement(
	        "div",
	        null,
	        Glamor.createElement(
	            _reactHelmet.Helmet,
	            { encodeSpecialCharacters: false },
	            Glamor.createElement("meta", { charSet: "utf-8" }),
	            Glamor.createElement("meta", { name: "description", content: "All blog posts under category " + data.contentfulCategory.name }),
	            Glamor.createElement(
	                "title",
	                null,
	                data.contentfulSiteSettings.title + " - " + data.contentfulCategory.name
	            )
	        ),
	        Glamor.createElement(
	            "header",
	            { className: "page-header" },
	            Glamor.createElement(
	                "div",
	                { className: "page-header-wrapper" },
	                Glamor.createElement(
	                    "h1",
	                    { className: "page-title" },
	                    "Category: ",
	                    data.contentfulCategory.name
	                )
	            )
	        ),
	        Glamor.createElement(
	            "section",
	            { className: "row posts-loop " },
	            data.allContentfulBlogPost && data.allContentfulBlogPost.edges.map(function (_ref2) {
	                var node = _ref2.node;
	                return Glamor.createElement(
	                    "div",
	                    { className: "post-wrapper col-12", key: node.slug },
	                    Glamor.createElement(
	                        "article",
	                        { className: "list-post post type-post status-publish format-standard hentry" },
	                        Glamor.createElement(
	                            "div",
	                            { className: "entry-header" },
	                            Glamor.createElement(_PostIcons2.default, { node: node, className: "entry-meta" }),
	                            Glamor.createElement(
	                                "h2",
	                                { className: "entry-title" },
	                                Glamor.createElement(_gatsbyLink2.default, { to: "/" + node.slug, dangerouslySetInnerHTML: { __html: node.title } })
	                            )
	                        ),
	                        Glamor.createElement(
	                            "div",
	                            { className: "entry-summary" },
	                            Glamor.createElement("span", { dangerouslySetInnerHTML: { __html: node.body.childMarkdownRemark.excerpt + ' [...] ' } }),
	                            Glamor.createElement(
	                                "span",
	                                { className: "read-more-link" },
	                                Glamor.createElement(
	                                    _gatsbyLink2.default,
	                                    { to: "/" + node.slug, className: "read-more" },
	                                    "Read More"
	                                )
	                            )
	                        )
	                    )
	                );
	            })
	        )
	    );
	};
	
	exports.default = Category;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-js-bf629bc717bfedb0a00b.js